module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('div', {
    staticClass: "wxOauth-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "wxOauth-loading"
  }, [_c('div', [_c('img', {
    staticClass: "wxOauth-img",
    attrs: {
      "src": require("../../../static/wxOauth/wxOauthLoading.gif")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wxOauth-span"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-961b4136!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/checkWXBind.vue
// module id = 1570
// module chunks = 18